import './dataSourceSingleGraph.less';
import { observer } from 'mobx-react';
import React from 'react';
import b_ from 'b_';

import { WidgetProps } from 'controls/designer/features/widgets/widgetProps';
import { DefaultWidgetWrapper } from 'controls/designer/features/widgets/defaultWidgetWrapper';
import { Section } from 'controls/react/layout/section';
import { BoxView } from 'controls/react/layout/boxView';
import { HighchartsWrapper } from 'components/HighchartsWrapper';
import { TimePeriodAppearance, TimePeriodSelector } from 'controls/react/form/timePeriodSelector';
import { TimePeriodType } from 'controls/react/form/timePeriodType';

import { DataSourceSingleGraphWidgetConfig } from './types';
import { DataSourceSingleGraphStore } from './DataSourceSingleGraphStore';

const b = b_.with('data-sources-single-graph');

const TimePeriods = [
	TimePeriodType.Last24Hours,
	TimePeriodType.Last7Days,
	TimePeriodType.Last30Days,
	TimePeriodType.Custom,
	TimePeriodType.DynamicInterval,
	TimePeriodType.All,
	TimePeriodType.LastN,
];

export const DataSourceSingleGraphWidget = observer(
	class InnerWidget extends React.Component<WidgetProps<DataSourceSingleGraphWidgetConfig>> {
		store: DataSourceSingleGraphStore;

		constructor(props: WidgetProps<DataSourceSingleGraphWidgetConfig>) {
			super(props);
			this.store = new DataSourceSingleGraphStore(props);
		}

		render() {
			const timePeriodSelector =
				this.props.config.hideTimePeriodSelector !== true ? (
					<TimePeriodSelector
						periods={TimePeriods}
						appearance={TimePeriodAppearance.Buttons}
						size={'small'}
						value={this.store.timePeriod}
						onChange={this.store.onPeriodChangeDebounced}
					/>
				) : null;

			return (
				<DefaultWidgetWrapper {...this.props} toolbarAtTheEnd={timePeriodSelector}>
					<Section
						appearance={'none'}
						height={'fit'}
						overlaySpinner={this.store.loading}
						contentOverlay={this.store.loading}
						contentClass={b()}
					>
						{!!this.store.errorMessage?.length && <BoxView type={'error'}>{this.store.errorMessage}</BoxView>}
						<HighchartsWrapper config={this.store.chartOptions} onClick={this.store.redirect} />
					</Section>
				</DefaultWidgetWrapper>
			);
		}

		async componentDidMount() {
			await this.store.init();
		}

		componentWillUnmount() {
			this.store?.destroy();
		}
	},
);
